import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
export var NoInstantAnswerSection = function NoInstantAnswerSection() {
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, {
    variant: "sectionHeaderSansMedium"
  }, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "s9WPlu",
    defaultMessage: [{
      "type": 0,
      "value": "Let’s find answers to resolve your issue"
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "prdLd3",
    defaultMessage: [{
      "type": 0,
      "value": "For a faster answer, take a look at the related articles listed below. Still got questions? Contact us for more help."
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "5x"
  }));
};